/**
 * Service to handle login redirects
 * Stores the intended destination URL before redirecting to login
 * and redirects to the stored URL after successful login
 */

const REDIRECT_URL_KEY = "redirectUrl";

export interface IRedirectService {
  setRedirectUrl: (url: string) => void;
  getRedirectUrl: () => string | null;
  clearRedirectUrl: () => void;
  hasRedirectUrl: () => boolean;
}

export default function RedirectService(): IRedirectService {
  const setRedirectUrl = (url: string) => {
    console.log("🔗 RedirectService: Setting redirect URL:", url);
    localStorage.setItem(REDIRECT_URL_KEY, url);
  };

  const getRedirectUrl = (): string | null => {
    const url = localStorage.getItem(REDIRECT_URL_KEY);
    console.log("🔗 RedirectService: Getting redirect URL:", url);
    return url;
  };

  const clearRedirectUrl = () => {
    console.log("🔗 RedirectService: Clearing redirect URL");
    localStorage.removeItem(REDIRECT_URL_KEY);
  };

  const hasRedirectUrl = (): boolean => {
    const hasUrl = localStorage.getItem(REDIRECT_URL_KEY) !== null;
    console.log("🔗 RedirectService: Has redirect URL:", hasUrl);
    return hasUrl;
  };

  return {
    setRedirectUrl,
    getRedirectUrl,
    clearRedirectUrl,
    hasRedirectUrl,
  };
}
